/* ==========================================================================
   FreezeCap™ — fc-main-article.liquid wiring (extracted in v6.30)
   --------------------------------------------------------------------------
   Copy-link button on blog articles. Uses navigator.clipboard with a
   2-second feedback toggle on aria-label. No Liquid interpolation —
   pure DOM behaviour.
   ========================================================================== */
(function () {
  function init() {
    var copyBtn = document.querySelector('[data-fc-copy-link]');
    if (!copyBtn) return;

    copyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          copyBtn.setAttribute('aria-label', 'Copied!');
          setTimeout(function () { copyBtn.setAttribute('aria-label', 'Copy link'); }, 2000);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
